const dayjs = require('dayjs');

let isSameOrBefore = require('dayjs/plugin/isSameOrBefore');
let isSameOrAfter = require('dayjs/plugin/isSameOrAfter');
let isBetween = require('dayjs/plugin/isBetween');
let duration = require('dayjs/plugin/duration');
let weekday = require('dayjs/plugin/weekday');
let isoWeek = require('dayjs/plugin/isoWeek');
let customParseFormat = require('dayjs/plugin/customParseFormat')
let utc = require('dayjs/plugin/utc');
let timezone = require('dayjs/plugin/timezone'); // dependent on utc plugin


dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isBetween);
dayjs.extend(duration);
dayjs.extend(weekday);
dayjs.extend(isoWeek);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

dayjs.tz.setDefault("America/Denver")

window.dayjs = dayjs;
